import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../../types/types';
import {
    SegmentCardEvent,
    SegmentCardOptions,
    segmentTrackAction
} from '../../../../../../../../../middlewares/segment';
import { SegmentCardSourceValue } from '../../../../../../../../../middlewares/segment/trackEntities/cardEvents';

export const onOpen = (
    isNewCard: boolean,
): ThunkAction => {
    return (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const option = isNewCard && {
            name: SegmentCardOptions.SOURCE,
            value: SegmentCardSourceValue.CARD_CREATION,
        };
        dispatch(segmentTrackAction(SegmentCardEvent.CARD_DATES_CLICKED, option));
    }
}
